import React, { FC } from 'react';
import { Edit } from '@wix/wix-ui-icons-common/on-stage';

import { classes } from './EditIcon.st.css';

export const EditIcon: FC = () => <Edit className={classes.root} />;
